let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4i4Kt")).then(() => parcelRequire('beOaf'));